import { DoorOpen } from "lucide-react";
import { CartaoComDestaque } from "@/components/shared/CartaoComDestaque";
import { useSalasAgora } from "@/components/salas/use-salas-agora";
import { DA_CLINICA, Resumo, Selo } from "./partes-do-cartao";

const plural = (n: number, um: string, varios: string) => `${n} ${n === 1 ? um : varios}`;

export function CartaoSalas() {
  const s = useSalasAgora();
  const emAtendimento = Object.values(s.porSala).filter((e) => e.tipo === "em-atendimento").length;

  const resumo = !s.temRecurso
    ? "Disponível no plano pago."
    : s.carregando
      ? "Carregando..."
      : s.salas.length
        ? `${plural(s.salas.length, "sala", "salas")} · ${emAtendimento} em atendimento agora`
        : "Nenhuma sala cadastrada ainda.";

  // Sem o recurso, /salas mostra o aviso do plano pago.
  return (
    <CartaoComDestaque
      cor="#7c3aed"
      icone={DoorOpen}
      titulo="Salas"
      descricao="Quem está em cada cadeira agora, a planta da clínica, a ocupação e o modo recepção."
      para="/salas"
      estado={DA_CLINICA}
      canto={!s.temRecurso ? <Selo tom="amber">Recurso pago</Selo> : undefined}
    >
      <Resumo>{resumo}</Resumo>
    </CartaoComDestaque>
  );
}
